import axios from '@fs/zion-axios'
import useErrorReporter from './useErrorReporter'
import useProfile from './useProfile'

const profileUrl = '/service/user/profile/users/CURRENT'

export default function useLanguage() {
  const { profile, profileLoading: languageLoading, updateLocalProfile } = useProfile()
  const reportError = useErrorReporter()

  const handleChangeLanguage = async (value) => {
    try {
      await axios.patch(profileUrl, { languages: { primary: { value, visibility: 'PRIVATE' } } })
      updateLocalProfile({ languages: { primary: { value, visibility: 'PRIVATE' } } })
    } catch (error) {
      reportError(error)
    }
  }

  return {
    preferredLang: profile?.languages?.primary?.value ?? '',
    languageLoading,
    handleChangeLanguage,
  }
}
